import axios from 'axios';
import { API_BASE_URL } from '../../config/ApiConfig';

const FNDE_API = API_BASE_URL.FNDE || '/api/fnde';

export const fndeService = {
  buscarSituacaoAtendimento: async (ano, cnpj) => {
    const token = localStorage.getItem('token');
    const headers = token ? { Authorization: `Bearer ${token}` } : undefined;
    const params = new URLSearchParams({ ano, cnpj });
    return axios.get(`${FNDE_API}/situacao-atendimento?${params.toString()}`, { headers });
  },

  buscarSaldoEntidade: async (mes, cnpj) => {
    const token = localStorage.getItem('token');
    const headers = token ? { Authorization: `Bearer ${token}` } : undefined;
    const params = new URLSearchParams({ mes, cnpj });
    return axios.get(`${FNDE_API}/saldo-entidade?${params.toString()}`, { headers });
  },

  buscarDadosEscola: async (ano, cnpj, co_escola = '') => {
    const token = localStorage.getItem('token');
    const headers = token ? { Authorization: `Bearer ${token}` } : undefined;
    // Se estiver consultando por co_escola, forçar cnpj vazio (print-mode) para
    // garantir que a versão impressa com valores numéricos completos seja retornada.
    const cnpjParam = co_escola && co_escola.toString().trim() !== '' ? '' : (cnpj || '');
    const params = new URLSearchParams({ ano, cnpj: cnpjParam, co_escola });
    return axios.get(`${FNDE_API}/dados-escola?${params.toString()}`, { headers });
  },

  testarConexao: async () => {
    const token = localStorage.getItem('token');
    const headers = token ? { Authorization: `Bearer ${token}` } : undefined;
    return axios.get(`${FNDE_API}/test`, { headers });
  }
};
